import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetIndividualsResponse } from "../type";
import type { GetQueries } from "@typings/api";
import { isEmpty } from "@utils/formatters";

async function getIndividuals(
  query: GetQueries,
): Promise<GetIndividualsResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;

    const paramKey = String(key) === "individual" ? "search" : key;

    params.append(paramKey, String(value));
  });

  let url = apiPaths.individuals.list;
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<GetIndividualsResponse>(url);

  return response.data;
}

export function useGetIndividuals(
  query: GetQueries | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [`fetch-get-individuals`, JSON.stringify(query ?? {})],
    () => getIndividuals(query ?? {}),
    mergedOptions,
  );
}
